import React, { useState } from 'react';
import DropDownItem from '../DropDown/drop-down-item-component';

const ModalNavbar = ({ formatter ,onTrigger}) => {
    const [openNavigation, setOpenNavigation] = useState(false);

    const handleToggleNavigation = () => {
        setOpenNavigation(!openNavigation);
    };

    return (
        <div className="relative">
            <button className={`${openNavigation?'fixed left-0 top-0 py-7 px-6 text-white z-50':'block'} transition-all `} onClick={handleToggleNavigation}>
                <svg
                    className="h-6 w-6 fill-current text-gray-500"
                    viewBox="0 0 24 24">
                    <path
                        fillRule="evenodd"
                        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                    />
                </svg>
            </button>

            <div
                className={`${openNavigation ? 'opacity-100 pointer-events-auto z-40' : 'opacity-0 pointer-events-none'} duration-500 ease-in-out fixed left-0 top-0 bg-white dark:bg-black w-screen h-screen transition-opacity`}>
                <div className="mt-32 h-2/3 w-screen items-center justify-center space-y-4 px-2 pt-2 pb-3">
                    <DropDownItem elements={formatter} onTrigger={onTrigger} fontStyle="font-bold" fontColor="text-black dark:text-white" fontSize="text-3xl" />
                </div>
            </div>
        </div>
    );
};

export default ModalNavbar;